// Fuente única de verdad de los temas especiales (se desbloquean con código)
const FLAG =
  'linear-gradient(180deg,#FCD116 0%,#FCD116 50%,#003893 50%,#003893 75%,#CE1126 75%,#CE1126 100%)'

export const SPECIAL_THEMES = {
  worldcup: {
    id: 'worldcup',
    code: 'PRIMERAESTRELLA',
    emoji: '🏆',
    preview: '🏆 ⚽ 🌎',
    accent: '#f7b500',
    glow: 'rgba(247,181,0,.35)',
    bg: 'radial-gradient(circle at center, rgba(247,181,0,.15), transparent 40%), linear-gradient(180deg,#021526 0%,#062a4f 100%)',
    logoBg: 'linear-gradient(135deg,#f7b500,#ffdd57)',
    keys: { name: 'tema_worldcup_nombre', desc: 'tema_worldcup_desc', greeting: 'saludo_mundial', loading: 'cargando_mundial' },
    decor: { motion: 'bounce', count: 5, emojis: ['⚽'] },
  },

  halloween: {
    id: 'halloween',
    code: 'HAWELIN',
    emoji: '🎃',
    preview: '🎃 👻 🦇',
    accent: '#ff7a00',
    glow: 'rgba(255,122,0,.35)',
    bg: 'radial-gradient(circle at center, rgba(255,122,0,.18), transparent 45%), linear-gradient(180deg,#0b0412 0%,#2a0f3d 100%)',
    logoBg: 'linear-gradient(135deg,#ff7a00,#7b2fd0)',
    keys: { name: 'tema_halloween_nombre', desc: 'tema_halloween_desc', greeting: 'saludo_halloween', loading: 'cargando_halloween' },
    decor: { motion: 'sway', count: 12, emojis: ['🦇', '👻', '🎃', '🕸️', '💀'] },
  },

  navidad: {
    id: 'navidad',
    code: 'CHRISTMAS2026',
    emoji: '🎄',
    preview: '🎄 🎅 ❄️',
    accent: '#f4c542',
    glow: 'rgba(244,197,66,.35)',
    bg: 'radial-gradient(circle at center, rgba(244,197,66,.16), transparent 45%), linear-gradient(180deg,#07170f 0%,#0f4a2c 100%)',
    logoBg: 'linear-gradient(135deg,#e63946,#2fbf71)',
    keys: { name: 'tema_navidad_nombre', desc: 'tema_navidad_desc', greeting: 'saludo_navidad', loading: 'cargando_navidad' },
    decor: { motion: 'fall', count: 18, emojis: ['❄️'] },
  },

  colombia: {
    id: 'colombia',
    code: 'C0LOMBIA2014', // ojo: es un CERO después de la C
    emoji: '☕',
    preview: '☕',
    accent: '#FCD116',
    glow: 'rgba(252,209,22,.35)',
    bg: `linear-gradient(rgba(0,0,0,.28),rgba(0,0,0,.28)), ${FLAG}`,
    logoBg: FLAG,
    keys: { name: 'tema_colombia_nombre', desc: 'tema_colombia_desc', greeting: 'saludo_colombia', loading: 'cargando_colombia' },
    decor: { motion: 'sway', count: 10, emojis: ['☕'] },
  },

  cerveza: {
    id: 'cerveza',
    code: 'SAMUMVP',
    emoji: '🍺',
    preview: '🍺 🍻 🥂',
    accent: '#f5a623',
    glow: 'rgba(245,166,35,.35)',
    bg: 'radial-gradient(circle at center, rgba(245,166,35,.2), transparent 45%), linear-gradient(180deg,#140b02 0%,#4a2a06 100%)',
    logoBg: 'linear-gradient(135deg,#ffcf4d,#d98b0b)',
    keys: { name: 'tema_cerveza_nombre', desc: 'tema_cerveza_desc', greeting: 'saludo_cerveza', loading: 'cargando_cerveza' },
    decor: { motion: 'rise', count: 14, emojis: ['🫧'] },
  },
}